import { chakra } from "@chakra-ui/react";
import { motion } from "framer-motion";

export const MotionContainer = chakra(motion.div);
